import React from 'react'
import './TPHeader.scss'
import STYLE from '../../base'

import TPLogo from '../TPLogo/TPLogo'

const ID_PHONE = 'tp-header-phone'

export const removeHeaderPhone = () => {
  if (window.document.getElementById(ID_PHONE)) {
    window.document.getElementById(ID_PHONE).remove()
  }
}


const Header = () => (
  <header className="page-header">
    <a href="/" className="logo"><TPLogo primaryColor={STYLE.colors.primary} secondaryColor={STYLE.colors.secondary} width="160"/></a>
    <a id={ ID_PHONE } href="tel:1300320288" aria-label="Phone number" className="phone-link">1300 320 288</a>
  </header>
)

export default Header
